import { atom } from 'recoil';
import { GlobalModalProps } from '../../types/navigation';


export const globalModalPropsState = atom<GlobalModalProps | undefined>({
  key: 'globalModalProps',
  default: undefined,
});
